import { lazy } from "react";
import Loadable from "src/routes/Loadable";

// Admin > Compliance (geofencing OFAC, TODO #1): revisione match SDN + esiti.
const SanctionsReview = Loadable(
  lazy(() => import("src/pages/admin/compliance/sanctionsReview/index"))
);

// Admin > Compliance: Semi-Annual Operations Report (report per paese).
const OperationsReport = Loadable(
  lazy(() => import("src/pages/admin/compliance/operationsReport/index"))
);

const compliance = [
  {
    path: "sanctions-review",
    element: <SanctionsReview />,
  },
  {
    path: "operations-report",
    element: <OperationsReport />,
  },
];

export default compliance;
